import { z } from 'zod';

export const shareModeSchema = z.enum([
  'AUTO_MONTHLY_PACKAGE',
  'READONLY_LINK',
  'BOTH',
]);
export type AccountantShareMode = z.infer<typeof shareModeSchema>;

export const SHARE_MODE_LABEL: Record<AccountantShareMode, string> = {
  AUTO_MONTHLY_PACKAGE: 'Pacote mensal automático',
  READONLY_LINK: 'Link read-only',
  BOTH: 'Pacote + link',
};

export const accountantFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Nome é obrigatório')
    .max(120, 'Máximo 120 caracteres'),
  email: z
    .string()
    .email('E-mail inválido')
    .max(320, 'Máximo 320 caracteres'),
  shareMode: shareModeSchema,
  monthlyPackageDay: z
    .number({ error: 'Dia obrigatório' })
    .int('Precisa ser inteiro')
    .min(1, 'Mínimo dia 1')
    .max(28, 'Máximo dia 28'),
});
export type AccountantFormInput = z.infer<typeof accountantFormSchema>;
